class DiceRollController {
  game: any;
  overlayEl: HTMLElement | null;
  isRolling: boolean;

  constructor(game: any) {
    this.game = game;
    this.overlayEl = null;
    this.isRolling = false;
  }

  rollDice() {
    if (this.isRolling) return;
    this.isRolling = true;

    // Random 2d6 roll
    const die1 = Math.floor(Math.random() * 6) + 1;
    const die2 = Math.floor(Math.random() * 6) + 1;
    const total = die1 + die2;

    this.showRollAnimation(die1, die2, total);
  }

  showRollAnimation(die1: number, die2: number, total: number) {
    // Remove existing overlay
    this.disposeOverlay();

    const overlay = document.createElement('div');
    overlay.className = 'dice-roll-overlay';

    // Rolling animation phase
    overlay.innerHTML =
      '<div class="dice-roll-container">' +
      '<div class="dice-roll-title">🎲 Rolling Dice...</div>' +
      '<div class="dice-roll-animation">' +
      '<span class="dice-rolling">⚀⚁⚂⚃⚄⚅</span>' +
      '</div>' +
      '</div>';
    document.body.appendChild(overlay);
    this.overlayEl = overlay;

    // After a short delay, show the result
    setTimeout(() => {
      if (!overlay.parentNode) return;
      overlay.innerHTML =
        '<div class="dice-roll-container">' +
        '<div class="dice-roll-title">Dice Roll</div>' +
        '<div class="dice-roll-result">' +
        '<span class="dice-die">' + this.getDieFace(die1) + '</span>' +
        '<span class="dice-plus">+</span>' +
        '<span class="dice-die">' + this.getDieFace(die2) + '</span>' +
        '<span class="dice-equals">=</span>' +
        '<span class="dice-total">' + total + '</span>' +
        '</div>' +
        '<div class="dice-roll-close-btn">Close</div>' +
        '</div>';

      overlay.querySelector('.dice-roll-close-btn')?.addEventListener('click', () => {
        this.disposeOverlay();
      });

      // Broadcast to room chat if multiplayer is active
      this.broadcastResult(die1, die2, total);

      this.isRolling = false;

      // Auto-close after 8 seconds
      setTimeout(() => {
        this.disposeOverlay();
      }, 8000);
    }, 1500);
  }

  getDieFace(value: number): string {
    const faces = ['', '⚀', '⚁', '⚂', '⚃', '⚄', '⚅'];
    return faces[value] || '?';
  }

  broadcastResult(die1: number, die2: number, total: number) {
    const game = this.game;
    const name = game.playerSlot || 'Someone';
    const msg = name + ' rolled ' + die1 + ' + ' + die2 + ' = ' + total;

    // Send via WebSocket if connected
    if (game.multiplayerConnectionController && game.multiplayerConnectionController.socket) {
      const ws = game.multiplayerConnectionController.socket;
      if (ws && ws.readyState === WebSocket.OPEN) {
        ws.send(JSON.stringify({
          type: 'chat',
          message: '/roll ' + die1 + ' ' + die2 + ' ' + total
        }));
      }
    }

    // Also show locally
    if (game.chatController && typeof game.chatController.addSystemMessage === 'function') {
      game.chatController.addSystemMessage(msg);
    }
  }

  disposeOverlay() {
    if (this.overlayEl && this.overlayEl.parentNode) {
      this.overlayEl.parentNode.removeChild(this.overlayEl);
    }
    this.overlayEl = null;
  }
}

export { DiceRollController };
